<script>
export default {
  name: 'PanelContainer',
  props: {
    id: {
      type: String,
      required: true,
    },
    modalParentId: {
      type: String,
    },
    title: {
      type: String,
    },
    usage: {
      type: [String, Array],
      default: 'dashboard',
    },
    modal: {
      type: Boolean,
      default: false,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    duplicatePanel: { // make a separate computed id for multiple usages
      default: false,
    },
  },
  methods: {
    async refreshPanels () {
      await this.$nextTick();
      const collidableEls = Array.from(this.$el.querySelectorAll('._collision'));
      const { height, width, x, y } = this.$el.getBoundingClientRect();
      const getAbsolutePos = ({ x, y }) => ({
        x: window.scrollX + x,
        y: window.scrollY + y,
      });
      const collisionRectangles = collidableEls.map(el => {
        const { height, width, x, y } = el.getBoundingClientRect();
        return { height, width, ...getAbsolutePos({ x, y }) };
      });
      this.usages.forEach((usage, i) => {
        this.$store.dispatch('registerPanel', {
          uid: `${this.id}${i}`,
          id: this.duplicatePanel ? `${this.id}-${usage}` : this.id,
          usage,
          modalParentId: this.modal ? (this.modalParentId || this.$route.query.modalParentId) : null,
          renderRectangle: {
            height,
            width,
            ...getAbsolutePos({ x, y }),
          },
          collisionRectangles,
        });
      });
    },
  },
  computed: {
    usages () {
      if (this.usage === 'auto') {
        return [this.$store.state.launcher.appState.overlay ? 'dashboard' : 'launcher'];
      }
      return Array.isArray(this.usage) ? this.usage : [this.usage];
    },
  },
  created () {
    this.refreshPanels();
  },
  updated () {
    this.refreshPanels();
  },
  destroyed () {
    this.usages.forEach((usage, i) => {
      this.$store.dispatch('unregisterPanel', `${this.id}${i}`);
    });
  },
};
</script>

<template lang="pug">
div.panel-container.flex.flex-column.relative
  h1.paneltitle.f4.white.tc.pv3.mb3.relative(:class="{'-empty': !title}", v-if="!noTitle") {{ title || '&nbsp;' }}
  div.wrapper.relative.flex-auto.h0
    slot
</template>

<style scoped>
.panel-container {
  & .paneltitle {
    &:after {
      content: "";
      border-bottom: 1px solid white;
      width: 40px;
      height: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      display: block;
      transform: translateX(-50%);
    }
    &.-empty:after {
      display: none;
    }
  }
  & .wrapper {
    max-height: 410px;
  }
}
</style>
<style>
.-debug .panel-container {
  &:before {
    content: "";
    z-index: 100;
    border: solid 3px red;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    pointer-events: none;
  }
  & ._collision {
    &:before {
      content: "";
      pointer-events: none;
      display: block;
      z-index: 100;
      border: solid 2px blue;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  }
}
</style>
